"use client";
import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { ChevronLeft, ChevronRight } from "lucide-react";

// ── Swiper Core Styles (Yahan Masla Tha, Inke Bina Carousel Vertically Toot Jata Hai) ──
import "swiper/css";

interface CarouselProps {
  children: React.ReactNode[];
}

const TopMerchantsCarousel = ({ children }: CarouselProps) => {
  const [swiperReady, setSwiperReady] = useState(false);

  return (
    <div className="relative group/wrap">

      {/* ── Prev button ── */}
      <button
        aria-label="Previous"
        className="carousel-prev-t9 absolute -left-5 top-[40%] -translate-y-1/2 z-20
          w-10 h-10 rounded-xl bg-white border-2 border-[#EADDCA]
          flex items-center justify-center text-[#800000]
          hover:bg-[#800000] hover:border-[#800000] hover:text-white
          opacity-0 group-hover/wrap:opacity-100
          shadow-[0_4px_16px_rgba(128,0,0,0.10)]
          transition-all duration-300 active:scale-90"
      >
        <ChevronLeft size={16} strokeWidth={2.5} />
      </button>

      {/* ── Next button ── */}
      <button
        aria-label="Next"
        className="carousel-next-t9 absolute -right-5 top-[40%] -translate-y-1/2 z-20
          w-10 h-10 rounded-xl bg-white border-2 border-[#EADDCA]
          flex items-center justify-center text-[#800000]
          hover:bg-[#800000] hover:border-[#800000] hover:text-white
          opacity-0 group-hover/wrap:opacity-100
          shadow-[0_4px_16px_rgba(128,0,0,0.10)]
          transition-all duration-300 active:scale-90"
      >
        <ChevronRight size={16} strokeWidth={2.5} />
      </button>

      {/* ── Swiper ── */}
      <Swiper
        modules={[Autoplay, Navigation]}
        spaceBetween={16}
        slidesPerView={2}
        loop
        autoplay={{ delay: 3500, disableOnInteraction: false }}
        navigation={{
          prevEl: ".carousel-prev-t9",
          nextEl: ".carousel-next-t9",
        }}
        onSwiper={() => setSwiperReady(true)}
        breakpoints={{
          480:  { slidesPerView: 3, spaceBetween: 16 },
          768:  { slidesPerView: 4, spaceBetween: 20 },
          1024: { slidesPerView: 5, spaceBetween: 24 },
          1280: { slidesPerView: 6, spaceBetween: 24 },
        }}
        className="w-full !pb-2"
      >
        {children.map((card, index) => (
          <SwiperSlide key={index} className="!h-auto py-3">
            {card}
          </SwiperSlide>
        ))}
      </Swiper>

    </div>
  );
};

export default TopMerchantsCarousel;
